import TranscriptTable from "./TranscriptTable";

export default TranscriptTable;